import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { DASHBOARD } from '../constants/routes';
import { useAdmin } from '../hooks/useAdmin';

export default function RequireAdmin() {
  const isAdmin = useAdmin();
  if (!isAdmin) {
    return <Navigate to={DASHBOARD} replace />;
  }
  return <Outlet />;
}
